var exports = {
  "zr": "x804f0401--5ce3ec--root",
  "DD": "x804f0401--5ce3ec--title",
  "PC": "x804f0401--5ce3ec--textarea",
  "hJ": "x804f0401--5ce3ec--counter",
  "Kk": "x804f0401--5ce3ec--icon",
};

module.exports = exports;
